/**
 * SenderIdManagementService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type TelcoEnums = 0 | 1 | 2 | 3;

export const TelcoEnums = {
    NUMBER_0: 0 as TelcoEnums,
    NUMBER_1: 1 as TelcoEnums,
    NUMBER_2: 2 as TelcoEnums,
    NUMBER_3: 3 as TelcoEnums
};